import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';

import { MotivoPerdaVendaSearchFilter } from '../filter';
import { MotivoPerdaVenda } from '../motivo-perda-venda';
import { MotivoPerdaVendaCrudHttpService } from '../services';
import { isMotivoPerdaVendaInativo, motivoPerdaVendaSituacaoAtivo } from '../situacao';

@Component({
    selector: 'sgt-motivo-perda-venda-select',
    templateUrl: './motivo-perda-venda-select.component.html',
    styleUrls: ['./motivo-perda-venda-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MotivoPerdaVendaSelectComponent), multi: true },
    ]
})
export class MotivoPerdaVendaSelectComponent implements OnInit {
    /** ID do motivo */
    @Input() ngModel: number;
    /** Ao alterar o motivo */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Motivo de Perda */
    @Input() motivoPerda: MotivoPerdaVenda;
    @Output() motivoPerdaChange = new EventEmitter<MotivoPerdaVenda>();

    /** Motivos */
    motivos: MotivoPerdaVenda[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se deve pesquisar os motivos ao iniciar o component */
    @Input() searchOnInit = true;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUM MOTIVO'
    /** Se deve filtrar somente os motivo ativos */
    @Input() somenteAtivos = false;
    /** Se deve filtrar somente os motivos que deve ser exibidos nas perdas de vendas */
    @Input() perdaVenda: boolean = null;
    /** Se deve filtrar somente os motivos que deve ser exibidos no congelamento dos clientes */
    @Input() clienteCongelado: boolean = null;
    /** Se deve filtrar somente os motivos que deve ser exibidos nos contatos dos clientes */
    @Input() contatoCliente: boolean = null;
    /** Se deve filtrar somente os motivos que deve ser exibidos as revisões de pedidos/orçamentos */
    @Input() revisaoPedidoOrcamento: boolean = null;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private motivoPerdaVendaCrudHttpService: MotivoPerdaVendaCrudHttpService) { }

    ngOnInit() {
        if (this.searchOnInit) {
            this.search();
        }
    }

    /** Cria o filter para pesquisar os motivos */
    private createFilter(): MotivoPerdaVendaSearchFilter {
        const filter = new MotivoPerdaVendaSearchFilter();
        // Somente ativos
        if (this.somenteAtivos) {
            filter.situacao = motivoPerdaVendaSituacaoAtivo.id;
        }

        // Perda Venda
        if (this.perdaVenda != null && this.perdaVenda !== undefined) {
            filter.perdaVenda = this.perdaVenda;
        }

        // Cliente Congelado
        if (this.clienteCongelado != null && this.clienteCongelado !== undefined) {
            filter.clienteCongelado = this.clienteCongelado;
        }

        // Contato Cliente
        if (this.contatoCliente != null && this.contatoCliente !== undefined) {
            filter.contatoCliente = this.contatoCliente;
        }

        // Revisão Pedidos/Orçamentos
        if (this.revisaoPedidoOrcamento != null && this.revisaoPedidoOrcamento !== undefined) {
            filter.revisaoPedidoOrcamento = this.revisaoPedidoOrcamento;
        }

        return filter;
    }


    /** Pesquisa os motivos */
    search(): Promise<MotivoPerdaVenda[]> {
        return new Promise<MotivoPerdaVenda[]>((resolve, reject) => {
            this.motivos = [];
            const filter = this.createFilter();
            this.motivoPerdaVendaCrudHttpService.searchWithFilter(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    motivos => {
                        this.motivos = motivos;

                        if (this.motivoPerda) {
                            const indexMotivo = this.motivos?.findIndex(motivoFilter => motivoFilter.id === this.motivoPerda.id);
                            if (indexMotivo < 0) {
                                this.motivos.unshift(this.motivoPerda);
                            }
                        }

                        resolve(this.motivos);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar os motivos', error);
                        reject(error);
                    }
                );
        });
    }

    /** Verifica se o motivo está inativo */
    isSituacaoInativo(situacao: number): boolean {
        return isMotivoPerdaVendaInativo(situacao);
    }

    /** Ao alterar o motivo */
    onChange(idMotivoPerda: number) {
        this.ngModel = idMotivoPerda;
        this.propagateChange(this.ngModel);

        this.motivoPerda = this.motivos?.find(motivoFilter => motivoFilter.id === idMotivoPerda);
        this.motivoPerdaChange.emit(this.motivoPerda);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
